import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  FormControl,
} from "react-bootstrap";
import TableData from "./component/tableData";
import AddNewStockExchange from "./component/Modal/AddNewStockExchange";
import add_new from "../../../Assets/svg/add_new.svg";
import { useSelector } from "react-redux";
import { get, updateToken } from "../../../helpers/api_helper";
import Pagination from "../../../components/Pagination";
import useCheckPermission from "../../../hooks/useCheckPermission";

const StockExchange = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [stockData, setStockData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const token = useSelector((state) => state.login.token);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const fetchStockData = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const skip = page;
        const response = await get(
          `/admin/stock-exchange?skip=${skip}&limit=${itemsPerPage}&search=${debouncedSearchQuery}`
        );
        if (response?.success) {
          setStockData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 1);
        } else {
          console.log("Failed to fetch stock data");
          setStockData([]);
        }
      } catch (err) {
        console.log("An error occurred while fetching stock data");
        setStockData([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage, debouncedSearchQuery]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchStockData(currentPage);
    }
  }, [token, fetchStockData, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleAddNewStock = () => {
    setModalMode("create");
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      <AddNewStockExchange
        showModal={showModal}
        setShowModal={setShowModal}
        handleDataRefresh={() => fetchStockData(currentPage)}
        mode={modalMode}
        resetFormOnClose={showModal}
      />
      <section className="userSec position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h5 className="m-0 fw-sbold">Markets Stocks Details</h5>
                  <p className="m-0 text-muted py-1">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text.
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  <FormControl
                    type="text"
                    placeholder="Search stocks"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="rounded-pill"
                    style={{ width: "200px" }}
                  />
                  {useCheckPermission("marketStock", "CREATE") && <Button
                    onClick={handleAddNewStock}
                    className="d-flex align-items-center justify-content-center rounded-pill"
                  >
                    Add Market Stock
                    <span className="icn ms-2">
                      <img src={add_new} alt="" />
                    </span>
                  </Button>}
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="commonTable scrollable-table-container">
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100px" }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : stockData.length > 0 ? (
                  <>
                    <TableData
                      stockData={stockData}
                      setRefresh={() => fetchStockData(currentPage)}
                    />
                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </>
                ) : (
                  <div className="d-flex justify-content-center align-items-center my-5">
                    <p>No stock data available.</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default StockExchange;
